export enum workspaceEnum {
    documentation = 'documentation',
    babylon = 'babylon',
}